import { useDeferredValue } from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useLoading } from '@/components/layout/loading/useLoading';
import * as m from '@/paraglide/messages.js';

import { JobDetailContent } from './-components/JobDetailContent';
import { jobsApi } from './-components/jobsApi';

const COLORS = { main: '#1DA6B3' };

export const Route = createFileRoute('/{-$locale}/internships/$id')({
  component: JobDetailPage,
  pendingComponent: () => <LoadingSpinner message={m.loading_offer()} />,
});

function JobDetailPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const deferredId = useDeferredValue(id);
  const { data } = jobsApi.useDetail(deferredId);
  useLoading(deferredId !== id);

  return (
    <div>
      <div className="mb-2 lg:hidden">
        <Button
          onClick={() => navigate({ to: '/{-$locale}/internships', search: (prev) => prev })}
          startIcon={<ArrowBackIcon />}
          sx={{ color: COLORS.main }}
        >
          {m.back_to_offers()}
        </Button>
      </div>
      <JobDetailContent job={data?.data} />
    </div>
  );
}
